import { isEmpty } from 'lodash';
import { connect } from 'react-redux';

import * as CliAppDefinition from 'app/entities/CliAppDefinition';
import * as DeveloperActions from 'app/developer-v3/Actions';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import PreloadPage from 'app/developer-v3/components/PreloadPage';
import hocify from 'app/common/components/hocify';
import {
  currentAppDefinitionEntity,
  currentDefinitionOverride,
  isCurrentAppDefinitionSaving,
} from 'app/developer-v3/selectors';

import AuthenticationPage from './AuthenticationPage';

const mapStateToProps = state => {
  const currentOverride = currentDefinitionOverride(state);
  const appDefinitionEntity = currentAppDefinitionEntity(state);
  const { authentication } = currentOverride;
  const isLegacy = !isEmpty(currentOverride.legacy?.authentication);

  const isLoadingApp = CliAppDefinition.selectors.isLoading(
    appDefinitionEntity
  );
  const isSaving = isCurrentAppDefinitionSaving(state);

  return {
    authentication,
    isLoading: isLoadingApp,
    isLegacy,
    isSaving,
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  onLoad() {
    const { id, version } = props.params;
    dispatch(DeveloperActions.loadAppAndVersion(id, version));
  },

  onDeleteAuthentication() {
    dispatch(DeveloperActions.deleteAuthentication());
  },

  onSaveAuthenticationSchemeType(type) {
    dispatch(DeveloperActions.saveAuthenticationSchemeType(type));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  hocify(LoadingBlockOrComponent, { LoadingComponent: PreloadPage })(
    AuthenticationPage
  )
);
